import React from 'react';

import { Button } from '@depop/web-ui-kit/Button';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { NavigationLink } from '@/components/Navigation/NavigationLink';
import { NavigationListItem } from '@/components/Navigation/NavigationListItem';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useSellNowHref } from '@/modules/signup/hooks/useSellNowHref';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function NavigationSellButton() {
  const t = useTranslations('common');
  const [isAuthenticated] = useCurrentUser();
  const { href } = useSellNowHref();
  const { sendActivityTrackerEvent } = useActivityTracker();

  function handleButtonClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.START_SELLER_HUB_ACTION);
  }

  return (
    <NavigationListItem
      // When logged in, display the button from tablet upwards
      // When logged out, display the button on desktop
      displayBreakpoint={isAuthenticated ? 'lgUp' : 'xlUp'}
      handleNavigationListItemClick={handleButtonClick}
    >
      <div className={styles.sellLinkWrapper}>
        <NavigationLink href={href}>
          <Button as="span" size="md">
            {t(`Nav.SellNow`)}
          </Button>
        </NavigationLink>
      </div>
    </NavigationListItem>
  );
}
